const styles = (theme) => ({
  errorContainer: {
    width: '100%',
    minHeight: '200px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '24px',
    boxSizing: 'border-box',
    backgroundColor: theme.ModalBGColor,
  },
  errorContent: {
    width: '100%',
    maxWidth: '600px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left'
  },
  errorHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    marginBottom: '16px'
  },
  errorHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  errorIcon: {
    fontSize: 48,
    color: theme.HeaderSelectedText,
    marginBottom: 0
  },
  errorTitle: {
    fontSize: 20,
    color: theme.HeaderSelectedText,
    fontWeight: 600,
    marginBottom: 0,
    fontFamily: 'Oxanium !important'
  },
  errorDescription: {
    color: theme.dispatchPanelLabelValueColor,
    fontSize: 14,
    marginBottom: 8,
    maxWidth: 400,
    lineHeight: 1.4,
    fontFamily: 'Oxanium !important'
  },
  compactContainer: {
    padding: '16px',
    minHeight: '150px'
  },
  compactTitle: {
    fontSize: 16,
    marginBottom: 6
  },
  compactDescription: {
    fontSize: 12,
    marginBottom: 12
  },
  closeButton: {
    backgroundColor: theme.ModalBGColor,
    color: theme.HeaderSelectedText,
    border: `1px solid ${theme.iconColor}`,
    textTransform: 'none',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: theme.iconColor,
      color: theme.ModalBGColor
    }
  },
  retryButton: {
    backgroundColor: theme.ModalBGColor,
    color: theme.HeaderSelectedText,
    border: `1px solid ${theme.iconColor}`,
    textTransform: 'none',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: theme.iconColor,
      color: theme.ModalBGColor
    }
  },

  errorDetailsContainer: {
    marginTop: 16,
    backgroundColor: theme.ModalBGColor,
    borderRadius: 8,
    border: `1px solid ${theme.iconColor}`,
    maxWidth: 500,
    overflow: 'hidden'
  },
  errorDetails: {
    padding: 16,
    fontSize: 12,
    fontFamily: 'monospace',
    maxHeight: 120,
    overflow: 'auto',
    color: theme.dispatchPanelLabelValueColor,
    lineHeight: 1.4,
    '& strong': {
      color: theme.HeaderSelectedText,
      fontWeight: 600
    },
    '& pre': {
      backgroundColor: `${theme.iconColor}0D`,
      padding: 8,
      borderRadius: 4,
      marginTop: 4,
      border: `1px solid ${theme.iconColor}`,
      margin: 0,
      fontSize: 10,
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word'
    }
  },
  toggleDetailsButton: {
    fontSize: 12,
    color: theme.HeaderSelectedText,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  actionButtons: {
    display: 'flex',
    gap: '8px',
    padding: '8px 16px',
    flexWrap: 'wrap',
    borderBottom: `1px solid ${theme.iconColor}`,
    backgroundColor: theme.ModalBGColor,
  },
  copyButton: {
    minWidth: 'auto',
    padding: '4px 8px',
    fontSize: 10,
    height: 28,
    backgroundColor: 'rgba(76, 175, 80, 1)',
    '&:hover': {
      backgroundColor: 'rgba(56, 142, 60, 1)'
    }
  },
  reportButton: {
    minWidth: 'auto',
    padding: '4px 8px',
    fontSize: 10,
    height: 28,
    backgroundColor: 'rgba(255, 152, 0, 1)',
    '&:hover': {
      backgroundColor: 'rgba(245, 124, 0, 1)'
    }
  },
  actionButton: {
    display: 'flex',
    gap: '8px',
    paddingTop: 14,
    width: '100%',
    height: 28,
    justifyContent: 'flex-end'
  }
});

export default styles;
